import Link from "next/link";
import React from "react";
import { useTracking } from "../../contexts/tracking-context";
import styles from "./SikkerhetStillinger.module.css";
//import metrics from "src/lib/metrics";

interface Props {
  tittel: string;
  beskrivelse?: string;
  url: string;
  bildeUrl?: string;
}

export const SikkerhetStillinger = () => {
  const { logEvent } = useTracking();

  const handleClick = (event: any) => {
    event.preventDefault();
    const url = event.currentTarget.href;
    const title = event.currentTarget.title;
    logEvent("Går til kampanjestilling", {
      title,
    });
    //metrics.clickStillingCounter.inc({ title, page: "sikkerhet" });
    window.location.assign(url);
  };

  return (
    <div className={styles.style}>
      <div className={styles.tekst}>
        <h2>Vi har mål som legger lista høyt. Vil du være med å bidra til at vi når dem?</h2>
        <p>
          Vi søker nå flere nye kollegaer innen sikkerhet. I NAV er vi over 200 team som sammen bygger verdens beste
          digitale arbeids- og velferdsløsninger!
        </p>
      </div>
      <div className={`${styles.flexContainer} ${styles.column}`}>
        <div className={`${styles.flexContainer} ${styles.row}`}>
          <a
            className={styles.stillingPanel}
            href="https://arbeidsplassen.nav.no/stillinger/stilling/dcc32fb3-670c-493d-942a-2a01339dfb25"
            title="Sommerjobb"
            onClick={handleClick}
          >
            <h3>Sommerjobb</h3>
            <p>
              Vil du ha en sommerjobb i 2025 hvor du kan gjøre en forskjell for våre brukere og samtidig jobbe med
              sikkerhet og personvern i anskaffelser i Nav?
            </p>
          </a>
        </div>
        <Link href="/#ledige-stillinger" passHref legacyBehavior>
          <a className={styles.stillingPanel}>
            <h3>Se flere ledige stillinger i NAV</h3>
            <p>Vi er stadig på utkikk etter nye kollegaer, sjekk ut andre ledige stillinger her!</p>
          </a>
        </Link>
      </div>
    </div>
  );
};
